import React from "react";
import { connect } from "react-redux";
import { submissionErrorHandler } from "../submissionErrorHandler";
import Component from "./component";
// import {authenticateDonor, sendVerificationCode} from 'actions/donor-login.actions'
import { forgotPassword } from "api/auth";
// import {match} from 'react-router'

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch) => {
  const sendVerificationCode = (form) => {
    return (dispatch, getState) => {
      let state = getState();

      return forgotPassword({
        phoneNumber: form.phoneNumber,
      })
        .then((s) => {
          return form.phoneNumber;
        })
        .catch(submissionErrorHandler);
    };
  };
  //
  // let promise = new Promise((resolve, reject) =>{
  //     resolve('3059756822')
  // })

  return {
    onSubmit: (form) => dispatch(sendVerificationCode(form)),
    // onSubmit: form => promise,
  };
};

// Connect to the store using a container component
const withConnect = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withConnect;
